import React, { Fragment } from 'react'

import { Dialog, Transition } from '@headlessui/react'
import classNames from 'classnames'

import { processMentionedEntity } from './utils'

interface ConfirmDeleteModal {
  isOpen: boolean
  isReply?: boolean
  setIsOpen: (isOpen: boolean) => void
  message: string
  onMessageDelete: () => void
}

export function ConfirmDeleteModal({
  isOpen,
  isReply = false,
  setIsOpen,
  message,
  onMessageDelete,
}: ConfirmDeleteModal) {
  const replyTextClassNames = classNames(
    {
      hidden: isReply,
    },
    'text-red-800'
  )

  return (
    <Transition
      appear
      show={isOpen}
      as={Fragment}
    >
      <Dialog
        as='div'
        className='relative z-20'
        onClose={() => setIsOpen(false)}
      >
        <Transition.Child
          as={Fragment}
          enter='ease-out duration-300'
          enterFrom='opacity-0'
          enterTo='opacity-100'
          leave='ease-in duration-200'
          leaveFrom='opacity-100'
          leaveTo='opacity-0'
        >
          <div className='fixed inset-0 bg-black bg-opacity-25' />
        </Transition.Child>

        <div className='fixed inset-0 overflow-y-auto'>
          <div className='flex min-h-full items-center justify-center p-4 text-center'>
            <Transition.Child
              as={Fragment}
              enter='ease-out duration-300'
              enterFrom='opacity-0 scale-95'
              enterTo='opacity-100 scale-100'
              leave='ease-in duration-200'
              leaveFrom='opacity-100 scale-100'
              leaveTo='opacity-0 scale-95'
            >
              <Dialog.Panel className='w-full max-w-lg transform overflow-hidden rounded-2xl bg-white p-6 text-left align-middle shadow-xl transition-all'>
                <Dialog.Title
                  as='h3'
                  className='text-lg font-medium leading-6 text-gray-900'
                >
                  Delete streaming note
                </Dialog.Title>
                <div className='mt-2 text-sm text-gray-500'>
                  <p>Are you sure you want to delete this note?</p>
                  <blockquote
                    className='bg-gray-100 rounded p-3 my-5 border-l-8'
                    dangerouslySetInnerHTML={{
                      __html: processMentionedEntity(message),
                    }}
                  />
                </div>

                <div className='mt-4'>
                  <button
                    data-test='confirm-delete'
                    type='button'
                    className='inline-flex justify-center rounded-md border border-transparent bg-red-100 px-4 py-2 text-sm font-medium text-red-900 hover:bg-red-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-red-500 focus-visible:ring-offset-2'
                    onClick={() => onMessageDelete()}
                  >
                    Confirm
                  </button>
                  <button
                    data-test='cancel-delete'
                    type='button'
                    className='inline-flex justify-center rounded-md bg-white px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus-visible:ring-2 focus-visible:ring-red-500 focus-visible:ring-offset-2 ml-2'
                    onClick={() => setIsOpen(false)}
                  >
                    Cancel
                  </button>
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition>
  )
}
